import type { UserInfo } from "../services/auth";

export function hasPermission(user: UserInfo | null | undefined, code: string): boolean {
  if (!user) return false;
  if (user.is_superuser) return true;
  return !!user.permissions?.includes(code);
}

export function ensurePermission(
  user: UserInfo | null | undefined,
  code: string,
  onDenied: (msg: string) => void,
): boolean {
  if (hasPermission(user, code)) return true;
  onDenied("你没有相关权限，请联系管理员");
  return false;
}
